import React from 'react';


export default function FieldNumberViewInImport(props) {

    return (
        <div className="ui5-txt-default-small">
            {props.value}
        </div>
    );
}